import React, { useState } from "react";
import styles from "./Faqs.module.css";

const faqList = [
  {
    q: "What image formats can I edit?",
    a: "Generally, any common raster image type: JPG, PNG, WebP, GIF, and BMP will all work fine. If your browser can show it, than the compressor can process it.",
  },
  {
    q: "Does the image get uploaded off of my computer?",
    a: "No. Canvas API does the compression all in your own browser, and nothing of your images gets uploaded or stored on our servers.",
  },
  {
    q: "Will compressing an image lower the quality of the image?",
    a: "Yes, a small amount. To compress an image you always sacrifice quality for a smaller size. Use the Quality slider to approximate the quality you are comfortable with prior to downloading.",
  },
  {
    q: "How do the inputs for width and height work?",
    a: "You can enter either dimension, or both. If you have 'Maintain aspect ratio' selected, the other dimension will auto-populate and adjust accordingly.",
  },
  {
    q: "Why can't I upload an image if it is larger than X MB?",
    a: "Browsers have memory restrictions. If you upload extremely large files, the tab can crash. We limit the uploads to 50 MB.",
  },
  {
    q: "Can I compress multiple images at once?",
    a: "Not in this version. Multiple or batch mode is on our roadmap, so stay tuned!",
  },
  {
    q: "Is it really free to use this tool?",
    a: "Yes. 100% totally free to use, no watermarks, no account permission required!",
  },
];

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className={`${styles.faqs} container`}>
      <h1 className={styles.title}>Frequently Asked Questions</h1>
      {faqList.map(({ q, a }, idx) => (
        <div
          key={idx}
          className={`${styles.faqItem} ${
            openIndex === idx ? styles.open : ""
          }`}
          onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
        >
          <div className={styles.question}>
            {q}
            <span className={styles.chevron}>
              {openIndex === idx ? "▴" : "▾"}
            </span>
          </div>
          <div className={styles.answer}>{a}</div>
        </div>
      ))}
    </section>
  );
}
